const vP18408 = require("../62.js");
const vLSSentryLogger = "Sentry Logger ";
const vA797 = ["debug", "info", "warn", "error", "log", "assert", "trace"];
function f2194(p18409) {
  if (!("console" in vP18408.a)) {
    return p18409();
  }
  const v14121 = vP18408.a.console;
  const vO478 = {};
  vA797.forEach(p18410 => {
    const v14122 = v14121[p18410] && v14121[p18410].__sentry_original__;
    if (p18410 in v14121 && v14122) {
      vO478[p18410] = v14121[p18410];
      v14121[p18410] = v14122;
    }
  });
  try {
    return p18409();
  } finally {
    Object.keys(vO478).forEach(p18411 => {
      v14121[p18411] = vO478[p18411];
    });
  }
}
function f2195() {
  let v14123 = false;
  const vO479 = {
    enable: () => {
      v14123 = true;
    },
    disable: () => {
      v14123 = false;
    }
  };
  if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
    vA797.forEach(p18412 => {
      vO479[p18412] = (...iIiîíîí) => {
        if (v14123) {
          f2194(() => {
            vP18408.a.console[p18412](vLSSentryLogger + "[" + p18412 + "]:", ...iIiîíîí);
          });
        }
      };
    });
  } else {
    vA797.forEach(p18413 => {
      vO479[p18413] = () => undefined;
    });
  }
  return vO479;
}
let v14124 = typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__ ? Object(vP18408.c)("logger", f2195) : f2195();
const vP184082 = require("../281.js");
const vA798 = ["fatal", "error", "warning", "log", "info", "debug"];
function f2196(p18414) {
  return f2197(p18414);
}
function f2197(p18415) {
  if (p18415 === "warn") {
    return "warning";
  } else if (vA798.includes(p18415)) {
    return p18415;
  } else {
    return "log";
  }
}
const vP184083 = require("../124.js");
class CaptureConsole {
  static __initStatic() {
    this.id = "CaptureConsole";
  }
  __init() {
    this.name = CaptureConsole.id;
  }
  __init2() {
    this._levels = vA797;
  }
  constructor(p18416 = {}) {
    CaptureConsole.prototype.__init.call(this);
    CaptureConsole.prototype.__init2.call(this);
    if (p18416.levels) {
      this._levels = p18416.levels;
    }
  }
  setupOnce(p18417, p18418) {
    if ("console" in vP18408.a) {
      this._levels.forEach(p18419 => {
        if (p18419 in vP18408.a.console) {
          Object(vP184082.c)(vP18408.a.console, p18419, p18420 => (...iÏiîïîi) => {
            const vP18418 = p18418();
            if (vP18418.getIntegration(CaptureConsole)) {
              vP18418.withScope(p18421 => {
                p18421.setLevel(f2197(p18419));
                p18421.setExtra("arguments", iÏiîïîi);
                p18421.addEventProcessor(p18422 => {
                  p18422.logger = "console";
                  return p18422;
                });
                let vObject3 = Object(vP184083.a)(iÏiîïîi, " ");
                if (p18419 === "assert") {
                  if (iÏiîïîi[0] === false) {
                    vObject3 = "Assertion failed: " + (Object(vP184083.a)(iÏiîïîi.slice(1), " ") || "console.assert");
                    p18421.setExtra("arguments", iÏiîïîi.slice(1));
                    vP18418.captureMessage(vObject3);
                  }
                } else if (p18419 === "error" && iÏiîïîi[0] instanceof Error) {
                  vP18418.captureException(iÏiîïîi[0]);
                } else {
                  vP18418.captureMessage(vObject3);
                }
              });
            }
            if (p18420) {
              p18420.apply(vP18408.a.console, iÏiîïîi);
            }
          });
        }
      });
    }
  }
}
exports.CaptureConsole = CaptureConsole;
CaptureConsole.__initStatic();
class Debug {
  static __initStatic() {
    this.id = "Debug";
  }
  __init() {
    this.name = Debug.id;
  }
  constructor(p18423) {
    Debug.prototype.__init.call(this);
    this._options = {
      debugger: false,
      stringify: false,
      ...p18423
    };
  }
  setupOnce(p18424, p18425) {
    p18424((p18426, p18427) => {
      const v14125 = p18425().getIntegration(Debug);
      if (v14125) {
        if (v14125._options.debugger) {
          debugger;
        }
        f2194(() => {
          if (v14125._options.stringify) {
            console.log(JSON.stringify(p18426, null, 2));
            if (Object.keys(p18427).length) {
              console.log(JSON.stringify(p18427, null, 2));
            }
          } else {
            console.log(p18426);
            if (Object.keys(p18427).length) {
              console.log(p18427);
            }
          }
        });
      }
      return p18426;
    });
  }
}
exports.Debug = Debug;
Debug.__initStatic();
class Dedupe {
  constructor() {
    Dedupe.prototype.__init.call(this);
  }
  static __initStatic() {
    this.id = "Dedupe";
  }
  __init() {
    this.name = Dedupe.id;
  }
  setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      if (currentEvent.type) {
        return currentEvent;
      }
      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        try {
          if (_shouldDropEvent(currentEvent, self._previousEvent)) {
            if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
              v14124.warn("Event dropped due to being a duplicate of previously captured event.");
            }
            return null;
          }
        } catch (e180) {
          return self._previousEvent = currentEvent;
        }
        return self._previousEvent = currentEvent;
      }
      return currentEvent;
    };
    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
}
exports.Dedupe = Dedupe;
Dedupe.__initStatic();
function _shouldDropEvent(p18431, p18432) {
  return !!p18432 && (!!f2199(p18431, p18432) || !!f2200(p18431, p18432));
}
function f2199(p18433, p18434) {
  const v14127 = p18433.message;
  const v14128 = p18434.message;
  return (!!v14127 || !!v14128) && (!v14127 || v14128) && (v14127 || !v14128) && v14127 === v14128 && !!f2202(p18433, p18434) && !!f2201(p18433, p18434);
}
function f2200(p18435, p18436) {
  const vIiii13 = f2203(p18436);
  const vIiii14 = f2203(p18435);
  return !!vIiii13 && !!vIiii14 && vIiii13.type === vIiii14.type && vIiii13.value === vIiii14.value && !!f2202(p18435, p18436) && !!f2201(p18435, p18436);
}
function f2201(p18437, p18438) {
  let vIii35 = f2204(p18437);
  let vIii36 = f2204(p18438);
  if (!vIii35 && !vIii36) {
    return true;
  }
  if (vIii35 && !vIii36 || !vIii35 && vIii36) {
    return false;
  }
  vIii35 = vIii35;
  vIii36 = vIii36;
  if (vIii36.length !== vIii35.length) {
    return false;
  }
  for (let vLN02602 = 0; vLN02602 < vIii36.length; vLN02602++) {
    const v14129 = vIii36[vLN02602];
    const v14130 = vIii35[vLN02602];
    if (v14129.filename !== v14130.filename || v14129.lineno !== v14130.lineno || v14129.colno !== v14130.colno || v14129.function !== v14130.function) {
      return false;
    }
  }
  return true;
}
function f2202(p18439, p18440) {
  let v14131 = p18439.fingerprint;
  let v14132 = p18440.fingerprint;
  if (!v14131 && !v14132) {
    return true;
  }
  if (v14131 && !v14132 || !v14131 && v14132) {
    return false;
  }
  v14131 = v14131;
  v14132 = v14132;
  try {
    return v14131.join("") === v14132.join("");
  } catch (e181) {
    return false;
  }
}
function f2203(p18441) {
  return p18441.exception && p18441.exception.values && p18441.exception.values[0];
}
function f2204(p18442) {
  const v14133 = p18442.exception;
  if (v14133) {
    try {
      return v14133.values[0].stacktrace.frames;
    } catch (e182) {}
  }
}
const vP184084 = require("../27.js");
const vP184085 = require("../407.js");
class ExtraErrorData {
  static __initStatic() {
    this.id = "ExtraErrorData";
  }
  __init() {
    this.name = ExtraErrorData.id;
  }
  constructor(p18443) {
    ExtraErrorData.prototype.__init.call(this);
    this._options = {
      depth: 3,
      ...p18443
    };
  }
  setupOnce(p18444, p18445) {
    p18444((p18446, p18447) => {
      const v14134 = p18445().getIntegration(ExtraErrorData);
      if (v14134) {
        return v14134.enhanceEventWithErrorData(p18446, p18447);
      } else {
        return p18446;
      }
    });
  }
  enhanceEventWithErrorData(p18448, p18449 = {}) {
    if (!p18449.originalException || !Object(vP184084.b)(p18449.originalException)) {
      return p18448;
    }
    const v14135 = p18449.originalException.name || p18449.originalException.constructor.name;
    const v14136 = this._extractErrorData(p18449.originalException);
    if (v14136) {
      const vO480 = {
        ...p18448.contexts
      };
      const vObject4 = Object(vP184085.a)(v14136, this._options.depth);
      if (Object(vP184084.f)(vObject4)) {
        Object(vP184082.a)(vObject4, "__sentry_skip_normalization__", true);
        vO480[v14135] = vObject4;
      }
      return {
        ...p18448,
        contexts: vO480
      };
    }
    return p18448;
  }
  _extractErrorData(p18450) {
    try {
      const vA799 = ["name", "message", "stack", "line", "column", "fileName", "lineNumber", "columnNumber", "toJSON"];
      const vO481 = {};
      for (const v14137 of Object.keys(p18450)) {
        if (vA799.indexOf(v14137) !== -1) {
          continue;
        }
        const v14138 = p18450[v14137];
        vO481[v14137] = Object(vP184084.b)(v14138) ? v14138.toString() : v14138;
      }
      if (typeof p18450.toJSON == "function") {
        const v14139 = p18450.toJSON();
        for (const v14140 of Object.keys(v14139)) {
          const v14141 = v14139[v14140];
          vO481[v14140] = Object(vP184084.b)(v14141) ? v14141.toString() : v14141;
        }
      }
      return vO481;
    } catch (e183) {
      if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
        v14124.error("Unable to extract extra data from the Error object:", e183);
      }
    }
    return null;
  }
}
exports.ExtraErrorData = ExtraErrorData;
ExtraErrorData.__initStatic();
function f2205() {
  const v14142 = vP18408.a;
  const v14143 = v14142.crypto || v14142.msCrypto;
  if (v14143 && v14143.randomUUID) {
    return v14143.randomUUID().replace(/-/g, "");
  }
  const v14144 = v14143 && v14143.getRandomValues ? () => v14143.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;
  return ([10000000] + 1000 + 4000 + 8000 + 100000000000).replace(/[018]/g, p18451 => (p18451 ^ (v14144() & 15) >> p18451 / 4).toString(16));
}
function f2206(p18452) {
  if (p18452.exception && p18452.exception.values) {
    return p18452.exception.values[0];
  } else {
    return undefined;
  }
}
function f2207(p18453) {
  const {
    message: iIïiiíí,
    event_id: iÌîîïîí
  } = p18453;
  if (iIïiiíí) {
    return iIïiiíí;
  }
  const vF2206 = f2206(p18453);
  if (vF2206) {
    if (vF2206.type && vF2206.value) {
      return vF2206.type + ": " + vF2206.value;
    } else {
      return vF2206.type || vF2206.value || iÌîîïîí || "<unknown>";
    }
  } else {
    return iÌîîïîí || "<unknown>";
  }
}
function f2208(p18454, p18455, p18456) {
  const v14145 = p18454.exception = p18454.exception || {};
  const v14146 = v14145.values = v14145.values || [];
  const v14147 = v14146[0] = v14146[0] || {};
  if (!v14147.value) {
    v14147.value = p18455 || "";
  }
  if (!v14147.type) {
    v14147.type = p18456 || "Error";
  }
}
function f2209(p18457, p18458) {
  const vF22062 = f2206(p18457);
  if (!vF22062) {
    return;
  }
  const v14148 = vF22062.mechanism;
  vF22062.mechanism = {
    ...{
      type: "generic",
      handled: true
    },
    ...v14148,
    ...p18458
  };
  if (p18458 && "data" in p18458) {
    const vO482 = {
      ...(v14148 && v14148.data),
      ...p18458.data
    };
    vF22062.mechanism.data = vO482;
  }
}
const v14149 = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function f2210(p18459) {
  const v14150 = p18459.match(v14149) || [];
  const vParseInt56 = parseInt(v14150[1], 10);
  const vParseInt57 = parseInt(v14150[2], 10);
  const vParseInt58 = parseInt(v14150[3], 10);
  return {
    buildmetadata: v14150[5],
    major: isNaN(vParseInt56) ? undefined : vParseInt56,
    minor: isNaN(vParseInt57) ? undefined : vParseInt57,
    patch: isNaN(vParseInt58) ? undefined : vParseInt58,
    prerelease: v14150[4]
  };
}
function f2211(p18460, p18461, p18462 = 5) {
  if (p18461.lineno === undefined) {
    return;
  }
  const v14151 = p18460.length;
  const v14152 = Math.max(Math.min(v14151, p18461.lineno - 1), 0);
  p18461.pre_context = p18460.slice(Math.max(0, v14152 - p18462), v14152).map(p18463 => Object(vP184083.b)(p18463, 0));
  p18461.context_line = Object(vP184083.b)(p18460[Math.min(v14151 - 1, v14152)], p18461.colno || 0);
  p18461.post_context = p18460.slice(Math.min(v14152 + 1, v14151), v14152 + 1 + p18462).map(p18464 => Object(vP184083.b)(p18464, 0));
}
function f2212(p18465) {
  if (p18465 && p18465.__sentry_captured__) {
    return true;
  }
  try {
    Object(vP184082.a)(p18465, "__sentry_captured__", true);
  } catch (e184) {}
  return false;
}
function f2213(p18466) {
  if (Array.isArray(p18466)) {
    return p18466;
  } else {
    return [p18466];
  }
}
const vP184086 = require("../310.js");
var v14153 = vP184086;
const v14154 = vP18408.a;
class Offline {
  static __initStatic() {
    this.id = "Offline";
  }
  __init() {
    this.name = Offline.id;
  }
  constructor(p18467 = {}) {
    Offline.prototype.__init.call(this);
    this.maxStoredEvents = p18467.maxStoredEvents || 30;
    this.offlineEventStore = v14153.createInstance({
      name: "sentry/offlineEventStore"
    });
  }
  setupOnce(p18468, p18469) {
    this.hub = p18469();
    if ("addEventListener" in v14154) {
      v14154.addEventListener("online", () => {
        this._sendEvents().catch(() => {
          if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
            v14124.warn("could not send cached events");
          }
        });
      });
    }
    const vF108 = p18470 => this.hub && this.hub.getIntegration(Offline) && "navigator" in v14154 && "onLine" in v14154.navigator && !v14154.navigator.onLine ? ((typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) && v14124.log("Event dropped due to being a offline - caching instead"), void this._cacheEvent(p18470).then(() => this._enforceMaxEvents()).catch(() => {
      if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
        v14124.warn("could not cache event while offline");
      }
    }), null) : p18470;
    vF108.id = this.name;
    p18468(vF108);
    if ("navigator" in v14154 && "onLine" in v14154.navigator && v14154.navigator.onLine) {
      this._sendEvents().catch(() => {
        if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
          v14124.warn("could not send cached events");
        }
      });
    }
  }
  async _cacheEvent(p18471) {
    return this.offlineEventStore.setItem(f2205(), Object(vP184085.a)(p18471));
  }
  async _enforceMaxEvents() {
    const vA800 = [];
    return this.offlineEventStore.iterate((p18472, p18473) => {
      vA800.push({
        cacheKey: p18473,
        event: p18472
      });
    }).then(() => this._purgeEvents(vA800.sort((p18474, p18475) => (p18475.event.timestamp || 0) - (p18474.event.timestamp || 0)).slice(this.maxStoredEvents < vA800.length ? this.maxStoredEvents : vA800.length).map(p18476 => p18476.cacheKey))).catch(() => {
      if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
        v14124.warn("could not enforce max events");
      }
    });
  }
  async _purgeEvent(p18477) {
    return this.offlineEventStore.removeItem(p18477);
  }
  async _purgeEvents(p18478) {
    return Promise.all(p18478.map(p18479 => this._purgeEvent(p18479))).then();
  }
  async _sendEvents() {
    return this.offlineEventStore.iterate((p18480, p18481) => {
      if (this.hub) {
        this.hub.captureEvent(p18480);
        this._purgeEvent(p18481).catch(() => {
          if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
            v14124.warn("could not purge event from cache");
          }
        });
      } else if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
        v14124.warn("no hub found - could not send cached event");
      }
    });
  }
}
exports.Offline = Offline;
Offline.__initStatic();
const vObject5 = Object(vP18408.b)();
function f2214() {
  try {
    new ErrorEvent("");
    return true;
  } catch (e185) {
    return false;
  }
}
function f2215() {
  try {
    new DOMError("");
    return true;
  } catch (e186) {
    return false;
  }
}
function f2216() {
  try {
    new DOMException("");
    return true;
  } catch (e187) {
    return false;
  }
}
function f2217() {
  if (!("fetch" in vObject5)) {
    return false;
  }
  try {
    new Headers();
    new Request("http://www.example.com");
    new Response();
    return true;
  } catch (e188) {
    return false;
  }
}
function f2218(p18482) {
  return p18482 && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(p18482.toString());
}
function f2219() {
  if (!f2217()) {
    return false;
  }
  if (f2218(vObject5.fetch)) {
    return true;
  }
  let v14155 = false;
  const v14156 = vObject5.document;
  if (v14156 && typeof v14156.createElement == "function") {
    try {
      const v14157 = v14156.createElement("iframe");
      v14157.hidden = true;
      v14156.head.appendChild(v14157);
      if (v14157.contentWindow && v14157.contentWindow.fetch) {
        v14155 = f2218(v14157.contentWindow.fetch);
      }
      v14156.head.removeChild(v14157);
    } catch (e189) {
      if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
        v14124.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e189);
      }
    }
  }
  return v14155;
}
function f2220() {
  return "ReportingObserver" in vObject5;
}
function f2221() {
  if (!f2217()) {
    return false;
  }
  try {
    new Request("_", {
      referrerPolicy: "origin"
    });
    return true;
  } catch (e190) {
    return false;
  }
}
function f2222() {
  const v14158 = vObject5.chrome;
  const v14159 = v14158 && v14158.app && v14158.app.runtime;
  const v14160 = "history" in vObject5 && !!vObject5.history.pushState && !!vObject5.history.replaceState;
  return !v14159 && v14160;
}
const v14161 = vP18408.a;
class ReportingObserver {
  static __initStatic() {
    this.id = "ReportingObserver";
  }
  __init() {
    this.name = ReportingObserver.id;
  }
  constructor(p18483 = {
    types: ["crash", "deprecation", "intervention"]
  }) {
    this._options = p18483;
    ReportingObserver.prototype.__init.call(this);
  }
  setupOnce(p18484, p18485) {
    if (f2220()) {
      this._getCurrentHub = p18485;
      const v14162 = new v14161.ReportingObserver(this.handler.bind(this), {
        buffered: true,
        types: this._options.types
      });
      v14162.observe();
    }
  }
  handler(p18486) {
    const v14163 = this._getCurrentHub && this._getCurrentHub();
    if (v14163 && v14163.getIntegration(ReportingObserver)) {
      for (const v14164 of p18486) {
        v14163.withScope(p18487 => {
          p18487.setExtra("url", v14164.url);
          const v14165 = "ReportingObserver [" + v14164.type + "]";
          let vLSNoDetailsAvailable = "No details available";
          if (v14164.body) {
            const vO483 = {};
            for (const v14166 in v14164.body) {
              vO483[v14166] = v14164.body[v14166];
            }
            p18487.setExtra("body", vO483);
            if (v14164.type === "crash") {
              const v14167 = v14164.body;
              vLSNoDetailsAvailable = [v14167.crashId || "", v14167.reason || ""].join(" ").trim() || vLSNoDetailsAvailable;
            } else {
              const v14168 = v14164.body;
              vLSNoDetailsAvailable = v14168.message || vLSNoDetailsAvailable;
            }
          }
          v14163.captureMessage(v14165 + ": " + vLSNoDetailsAvailable);
        });
      }
    }
  }
}
exports.ReportingObserver = ReportingObserver;
ReportingObserver.__initStatic();
function f2223(p18488, p18489) {
  let vLN02603 = 0;
  for (let v14169 = p18488.length - 1; v14169 >= 0; v14169--) {
    const v14170 = p18488[v14169];
    if (v14170 === ".") {
      p18488.splice(v14169, 1);
    } else if (v14170 === "..") {
      p18488.splice(v14169, 1);
      vLN02603++;
    } else if (vLN02603) {
      p18488.splice(v14169, 1);
      vLN02603--;
    }
  }
  if (p18489) {
    for (; vLN02603--; vLN02603) {
      p18488.unshift("..");
    }
  }
  return p18488;
}
const v14171 = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
function f2224(p18490) {
  const v14172 = v14171.exec(p18490);
  if (v14172) {
    return v14172.slice(1);
  } else {
    return [];
  }
}
function f2225(...iÏïìiïî) {
  let vLS120 = "";
  let v14173 = false;
  for (let v14174 = iÏïìiïî.length - 1; v14174 >= -1 && !v14173; v14174--) {
    const v14175 = v14174 >= 0 ? iÏïìiïî[v14174] : "/";
    if (v14175) {
      vLS120 = v14175 + "/" + vLS120;
      v14173 = v14175.charAt(0) === "/";
    }
  }
  vLS120 = f2223(vLS120.split("/").filter(p18491 => !!p18491), !v14173).join("/");
  return (v14173 ? "/" : "") + vLS120 || ".";
}
function f2226(p18492) {
  let vLN02604 = 0;
  for (; vLN02604 < p18492.length && p18492[vLN02604] === ""; vLN02604++) {
    ;
  }
  let v14176 = p18492.length - 1;
  for (; v14176 >= 0 && p18492[v14176] === ""; v14176--) {
    ;
  }
  if (vLN02604 > v14176) {
    return [];
  } else {
    return p18492.slice(vLN02604, v14176 - vLN02604 + 1);
  }
}
function f2227(p18493, p18494) {
  p18493 = f2225(p18493).slice(1);
  p18494 = f2225(p18494).slice(1);
  const vF2226 = f2226(p18493.split("/"));
  const vF22262 = f2226(p18494.split("/"));
  const v14177 = Math.min(vF2226.length, vF22262.length);
  let vV14177 = v14177;
  for (let vLN02605 = 0; vLN02605 < v14177; vLN02605++) {
    if (vF2226[vLN02605] !== vF22262[vLN02605]) {
      vV14177 = vLN02605;
      break;
    }
  }
  let vA801 = [];
  for (let vVV14177 = vV14177; vVV14177 < vF2226.length; vVV14177++) {
    vA801.push("..");
  }
  vA801 = vA801.concat(vF22262.slice(vV14177));
  return vA801.join("/");
}
function f2228(p18495) {
  const vIiii15 = f2229(p18495);
  const v14178 = p18495.slice(-1) === "/";
  let v14179 = f2223(p18495.split("/").filter(p18496 => !!p18496), !vIiii15).join("/");
  if (!v14179 && !vIiii15) {
    v14179 = ".";
  }
  if (v14179 && v14178) {
    v14179 += "/";
  }
  return (vIiii15 ? "/" : "") + v14179;
}
function f2229(p18497) {
  return p18497.charAt(0) === "/";
}
function f2230(...iÌïíïìì) {
  return f2228(iÌïíïìì.join("/"));
}
function f2231(p18498) {
  const vF2224 = f2224(p18498);
  const v14180 = vF2224[0];
  let v14181 = vF2224[1];
  if (v14180 || v14181) {
    if (v14181) {
      v14181 = v14181.slice(0, v14181.length - 1);
    }
    return v14180 + v14181;
  } else {
    return ".";
  }
}
function f2232(p18499, p18500) {
  let v14182 = f2224(p18499)[2];
  if (p18500 && v14182.slice(p18500.length * -1) === p18500) {
    v14182 = v14182.slice(0, v14182.length - p18500.length);
  }
  return v14182;
}
class RewriteFrames {
  static __initStatic() {
    this.id = "RewriteFrames";
  }
  __init() {
    this.name = RewriteFrames.id;
  }
  __init2() {
    this._prefix = "app:///";
  }
  constructor(p18501 = {}) {
    RewriteFrames.prototype.__init.call(this);
    RewriteFrames.prototype.__init2.call(this);
    RewriteFrames.prototype.__init3.call(this);
    if (p18501.root) {
      this._root = p18501.root;
    }
    if (p18501.prefix) {
      this._prefix = p18501.prefix;
    }
    if (p18501.iteratee) {
      this._iteratee = p18501.iteratee;
    }
  }
  setupOnce(p18502, p18503) {
    p18502(p18504 => {
      const v14183 = p18503().getIntegration(RewriteFrames);
      if (v14183) {
        return v14183.process(p18504);
      } else {
        return p18504;
      }
    });
  }
  process(p18505) {
    let vP18505 = p18505;
    if (p18505.exception && Array.isArray(p18505.exception.values)) {
      vP18505 = this._processExceptionsEvent(vP18505);
    }
    return vP18505;
  }
  __init3() {
    this._iteratee = p18506 => {
      if (!p18506.filename) {
        return p18506;
      }
      const v14184 = /^[A-Z]:\\/.test(p18506.filename);
      const v14185 = /^\//.test(p18506.filename);
      if (v14184 || v14185) {
        const v14186 = v14184 ? p18506.filename.replace(/^[A-Z]:/, "").replace(/\\/g, "/") : p18506.filename;
        const v14187 = this._root ? f2227(this._root, v14186) : f2232(v14186);
        p18506.filename = "" + this._prefix + v14187;
      }
      return p18506;
    };
  }
  _processExceptionsEvent(p18507) {
    try {
      return {
        ...p18507,
        exception: {
          ...p18507.exception,
          values: p18507.exception.values.map(p18508 => ({
            ...p18508,
            ...(p18508.stacktrace && {
              stacktrace: this._processStacktrace(p18508.stacktrace)
            })
          }))
        }
      };
    } catch (e191) {
      return p18507;
    }
  }
  _processStacktrace(p18509) {
    return {
      ...p18509,
      frames: p18509 && p18509.frames && p18509.frames.map(p18510 => this._iteratee(p18510))
    };
  }
}
exports.RewriteFrames = RewriteFrames;
RewriteFrames.__initStatic();
class SessionTiming {
  constructor() {
    SessionTiming.prototype.__init.call(this);
    SessionTiming.prototype.__init2.call(this);
  }
  static __initStatic() {
    this.id = "SessionTiming";
  }
  __init() {
    this.name = SessionTiming.id;
  }
  __init2() {
    this._startTime = Date.now();
  }
  setupOnce(p18511, p18512) {
    p18511(p18513 => {
      const v14188 = p18512().getIntegration(SessionTiming);
      if (v14188) {
        return v14188.process(p18513);
      } else {
        return p18513;
      }
    });
  }
  process(p18514) {
    const v14189 = Date.now();
    return {
      ...p18514,
      extra: {
        ...p18514.extra,
        "session:start": this._startTime,
        "session:duration": v14189 - this._startTime,
        "session:end": v14189
      }
    };
  }
}
exports.SessionTiming = SessionTiming;
SessionTiming.__initStatic();
class Transaction {
  constructor() {
    Transaction.prototype.__init.call(this);
  }
  static __initStatic() {
    this.id = "Transaction";
  }
  __init() {
    this.name = Transaction.id;
  }
  setupOnce(p18515, p18516) {
    p18515(p18517 => {
      const v14190 = p18516().getIntegration(Transaction);
      if (v14190) {
        return v14190.process(p18517);
      } else {
        return p18517;
      }
    });
  }
  process(p18518) {
    const v14191 = this._getFramesFromEvent(p18518);
    for (let v14192 = v14191.length - 1; v14192 >= 0; v14192--) {
      const v14193 = v14191[v14192];
      if (v14193.in_app === true) {
        p18518.transaction = this._getTransaction(v14193);
        break;
      }
    }
    return p18518;
  }
  _getFramesFromEvent(p18519) {
    const v14194 = p18519.exception && p18519.exception.values && p18519.exception.values[0];
    return v14194 && v14194.stacktrace && v14194.stacktrace.frames || [];
  }
  _getTransaction(p18520) {
    if (p18520.module || p18520.function) {
      return (p18520.module || "?") + "/" + (p18520.function || "?");
    } else {
      return "<unknown>";
    }
  }
}
exports.Transaction = Transaction;
Transaction.__initStatic();
class HttpClient {
  static __initStatic() {
    this.id = "HttpClient";
  }
  __init() {
    this.name = HttpClient.id;
  }
  constructor(p18521) {
    HttpClient.prototype.__init.call(this);
    this._options = {
      failedRequestStatusCodes: [[500, 599]],
      failedRequestTargets: [/.*/],
      ...p18521
    };
  }
  setupOnce(p18522, p18523) {
    this._getCurrentHub = p18523;
    this._wrapFetch();
    this._wrapXHR();
  }
  _fetchResponseHandler(p18524, p18525, p18526) {
    if (this._getCurrentHub && this._shouldCaptureResponse(p18525.status, p18525.url)) {
      const v14195 = new Request(p18524, p18526);
      const v14196 = this._getCurrentHub();
      let v14197;
      let v14198;
      let v14199;
      let v14200;
      if (v14196.shouldSendDefaultPii()) {
        [{
          headers: v14197,
          cookies: v14199
        }, {
          headers: v14198,
          cookies: v14200
        }] = [{
          cookieHeader: "Cookie",
          obj: v14195
        }, {
          cookieHeader: "Set-Cookie",
          obj: p18525
        }].map(({
          cookieHeader: iÍîíìïi,
          obj: iIïïiïí
        }) => {
          const v14201 = this._extractFetchHeaders(iIïïiïí.headers);
          let v14202;
          try {
            const v14203 = v14201[iÍîíìïi] || v14201[iÍîíìïi.toLowerCase()] || undefined;
            if (v14203) {
              v14202 = this._parseCookieString(v14203);
            }
          } catch (e192) {
            if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
              v14124.log("Could not extract cookies from header " + iÍîíìïi);
            }
          }
          return {
            headers: v14201,
            cookies: v14202
          };
        });
      }
      const v14204 = this._createEvent({
        url: v14195.url,
        method: v14195.method,
        status: p18525.status,
        requestHeaders: v14197,
        responseHeaders: v14198,
        requestCookies: v14199,
        responseCookies: v14200
      });
      v14196.captureEvent(v14204);
    }
  }
  _xhrResponseHandler(p18527, p18528, p18529) {
    if (this._getCurrentHub && this._shouldCaptureResponse(p18527.status, p18527.responseURL)) {
      let v14205;
      let v14206;
      let v14207;
      const v14208 = this._getCurrentHub();
      if (v14208.shouldSendDefaultPii()) {
        try {
          const v14209 = p18527.getResponseHeader("Set-Cookie") || p18527.getResponseHeader("set-cookie") || undefined;
          if (v14209) {
            v14206 = this._parseCookieString(v14209);
          }
        } catch (e193) {
          if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
            v14124.log("Could not extract cookies from response headers");
          }
        }
        try {
          v14207 = this._getXHRResponseHeaders(p18527);
        } catch (e194) {
          if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
            v14124.log("Could not extract headers from response");
          }
        }
        v14205 = p18529;
      }
      const v14210 = this._createEvent({
        url: p18527.responseURL,
        method: p18528,
        status: p18527.status,
        requestHeaders: v14205,
        responseHeaders: v14207,
        responseCookies: v14206
      });
      v14208.captureEvent(v14210);
    }
  }
  _getResponseSizeFromHeaders(p18530) {
    if (p18530) {
      const v14211 = p18530["Content-Length"] || p18530["content-length"];
      if (v14211) {
        return parseInt(v14211, 10);
      }
    }
  }
  _parseCookieString(p18531) {
    return p18531.split("; ").reduce((p18532, p18533) => {
      const [v14212, v14213] = p18533.split("=");
      p18532[v14212] = v14213;
      return p18532;
    }, {});
  }
  _extractFetchHeaders(p18534) {
    const vO484 = {};
    p18534.forEach((p18535, p18536) => {
      vO484[p18536] = p18535;
    });
    return vO484;
  }
  _getXHRResponseHeaders(p18537) {
    const v14214 = p18537.getAllResponseHeaders();
    if (v14214) {
      return v14214.split("\r\n").reduce((p18538, p18539) => {
        const [v14215, v14216] = p18539.split(": ");
        p18538[v14215] = v14216;
        return p18538;
      }, {});
    } else {
      return {};
    }
  }
  _isInGivenRequestTargets(p18540) {
    return !!this._options.failedRequestTargets && this._options.failedRequestTargets.some(p18541 => typeof p18541 == "string" ? p18540.includes(p18541) : p18541.test(p18540));
  }
  _isInGivenStatusRanges(p18542) {
    return !!this._options.failedRequestStatusCodes && this._options.failedRequestStatusCodes.some(p18543 => typeof p18543 == "number" ? p18543 === p18542 : p18542 >= p18543[0] && p18542 <= p18543[1]);
  }
  _wrapFetch() {
    if (!f2219()) {
      return;
    }
    const vThis143 = this;
    Object(vP184082.c)(vP18408.a, "fetch", function (p18544) {
      return function (...iÍííììi) {
        const [v14217, v14218] = iÍííììi;
        const v14219 = p18544.apply(this, iÍííììi);
        v14219.then(p18545 => {
          vThis143._fetchResponseHandler(v14217, p18545, v14218);
          return p18545;
        }).catch(p18546 => {
          throw p18546;
        });
        return v14219;
      };
    });
  }
  _wrapXHR() {
    if (!("XMLHttpRequest" in vP18408.a)) {
      return;
    }
    const vThis144 = this;
    Object(vP184082.c)(XMLHttpRequest.prototype, "open", function (p18547) {
      return function (...iÎîiìíí) {
        const vThis145 = this;
        const v14220 = iÎîiìíí[0];
        const vO485 = {};
        Object(vP184082.c)(vThis145, "setRequestHeader", function (p18548) {
          return function (...iÎïììii) {
            const [v14221, v14222] = iÎïììii;
            vO485[v14221] = v14222;
            return p18548.apply(vThis145, iÎïììii);
          };
        });
        Object(vP184082.c)(vThis145, "onloadend", function (p18549) {
          return function (...iIììïïï) {
            try {
              vThis144._xhrResponseHandler(vThis145, v14220, vO485);
            } catch (e195) {
              if (typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__) {
                v14124.warn("Error while extracting response event form XHR response", e195);
              }
            }
            if (p18549) {
              return p18549.apply(vThis145, iIììïïï);
            }
          };
        });
        return p18547.apply(this, iÎîiìíí);
      };
    });
  }
  _isSentryRequest(p18550) {
    const v14223 = this._getCurrentHub && this._getCurrentHub().getClient();
    if (!v14223) {
      return false;
    }
    const v14224 = v14223.getDsn();
    return !!v14224 && p18550.includes(v14224.host);
  }
  _shouldCaptureResponse(p18551, p18552) {
    return this._isInGivenStatusRanges(p18551) && this._isInGivenRequestTargets(p18552) && !this._isSentryRequest(p18552);
  }
  _createEvent(p18553) {
    const v14225 = "HTTP Client Error with status code: " + p18553.status;
    const vO486 = {
      message: v14225,
      exception: {
        values: [{
          type: "Error",
          value: v14225
        }]
      },
      request: {
        url: p18553.url,
        method: p18553.method,
        headers: p18553.requestHeaders,
        cookies: p18553.requestCookies
      },
      contexts: {
        response: {
          status_code: p18553.status,
          headers: p18553.responseHeaders,
          cookies: p18553.responseCookies,
          body_size: this._getResponseSizeFromHeaders(p18553.responseHeaders)
        }
      }
    };
    f2209(vO486, {
      type: "http.client"
    });
    return vO486;
  }
}
exports.HttpClient = HttpClient;
HttpClient.__initStatic();